const BrushIcon = (
  <svg
    className="fill-current"
    width="18"
    height="18"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M19,0H5C2.243,0,0,2.243,0,5v14c0,2.757,2.243,5,5,5h14c2.757,0,5-2.243,5-5V5c0-2.757-2.243-5-5-5Zm3,19c0,1.654-1.346,3-3,3H5c-1.654,0-3-1.346-3-3V5c0-1.654,1.346-3,3-3h14c1.654,0,3,1.346,3,3v14Zm-4-11v8c0,.552-.448,1-1,1s-1-.448-1-1v-8c0-.552.448-1,1-1s1,.448,1,1Zm-4,0v5c0,2.206-1.794,4-4,4s-4-1.794-4-4v-5c0-.552.448-1,1-1s1,.448,1,1v5c0,1.103.897,2,2,2s2-.897,2-2v-5c0-.552.448-1,1-1s1,.448,1,1Z"/>
  </svg>
);

export default BrushIcon;
